import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import store from './store';
import { Router, Route, Switch } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';

import edit_policy from './components/edit_policy/edit_policy';
import './components/edit_policy/edit_policy.css';
import './components/topHeader/topHeader.css';
import Search from './components/search/Search';
import Seatchart from './components/seatchart/seatchart_reschedule';
import Checkout from './components/checkout/checkout';

//import './index.css';
const browserHistory = createBrowserHistory();

//import App from './App';
//import * as serviceWorker from './serviceWorker';

//ReactDOM.render(<App />, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();

ReactDOM.render(
	<Provider store = {store} >
        <Router history = { browserHistory } >
            <Switch>
            	<Route path = "/edit_policy" component = { edit_policy } />
                <Route path = "/ticket/editbooking/:pnrNo" component = { Search } />
                <Route path = "/seatcharts/:rsid/:fromCityId/:fromCityName/:toCityId/:toCityName/:depDate/:mode/:pnrNo/:depTime" component = { Seatchart } />
                <Route path = "/co/exps/:token/:pnrNo" component = { Checkout } />
            </Switch>
        </Router>
    </Provider>, 
    document.getElementById('root')
)


// WEBPACK FOOTER //
// ./src/index.js